//# sourceMappingURL=prism.type.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/prism/core/prism.type.js
// module id = 274
// module chunks = 7